<template>
  <aha-modal
    @hide="hideModal"
    title="You’re not leading this presentation"
  >
    <p class="mb-2">
      You can change this setting now:
    </p>
    <div class="bg-secondary-10 px-3 py-2.5">
      <p class="mb-2 font-bold">
        Who takes the lead?
      </p>
      <aha-radio
        class="mb-2.5"
        name="whoTakesTheLead"
        :value="false"
        v-model="$store.state.presentation.audiencePacing"
        @change="onChangeAudiencePacing"
      >
        Presenter
        <aha-icon
          class="ml-1 text-base-70"
          name="question"
          viewBox="0 0 24 24"
          width="15"
          height="15"
          v-tooltip="presenterPacingTooltip"
        />
      </aha-radio>

      <aha-radio
        name="whoTakesTheLead"
        :value="true"
        v-model="$store.state.presentation.audiencePacing"
        @change="onChangeAudiencePacing"
      >
        Audience (self-paced)
        <aha-icon
          class="ml-1 text-base-70"
          name="question"
          viewBox="0 0 24 24"
          width="15"
          height="15"
          v-tooltip="'Participants start from the first slide ' +
            'and proceed on their own. Great for surveys'"
        />
      </aha-radio>
    </div>
    <template #action>
      <aha-link
        class="mr-6"
        @click="hideModal"
      >
        <span class="font-bold">Cancel</span>
      </aha-link>
      <aha-button
        @click="$emit('present')"
        type="submit"
      >
        Present Now
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import Util from '@/util'
import Config from '@/config'
import Socket from '@/socket'
import gaCategories from '@/constant/gaCategories'

export default {
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    presenterPacingTooltip() {
      return 'The audience follow you. They can\'t proceed to the next slide on their own.'
    },
  },
  methods: {
    ...mapActions(['setSyncLoadingAction']),
    onChangeAudiencePacing() {
      const payload = {
        socketId: Socket.getSocketId(),
        audiencePacing: this.$store.state.presentation.audiencePacing,
      }
      this.setSyncLoadingAction(1)
      this.updatePresentation(payload)
      let name = 'presenter'
      if (this.$store.state.presentation.audiencePacing) {
        name = 'audience'
      }
      Util.gaTrackEvent(gaCategories.PRESENTATION_EDITOR, 'Settings menu > Who takes the lead', name)
    },
    updatePresentation(payload) {
      this.$http
        .put(Config.api.updatePresentation + this.$route.params.id, payload)
        .then(
          () => {
            this.setSyncLoadingAction(2)
          },
          () => {
            this.setSyncLoadingAction(3)
          },
        )
    },
    hideModal() {
      this.$emit('hide')
    },
  },
}
</script>
